export const FORM_MILESTONES = [
    'formLoad',
    'formChange',
    'formValidate',
    'formSubmit',
    'formPostSubmit',
];
